import Webapi from 'OK/webapi';
import ReactInitializer from 'OK/react/ReactInitializer';

var tagsCache = {};

class TagInfo {
    constructor(params) {
        /**
         * @type {string}
         */
        this.name = params.name;
        /**
         * @type {string}
         */
        this.version = params.version;
        /**
         * @type {string}
         */
        this.js = params.js;

        /**
         * @type {string}
         */
        this.bundleName = params.bundleName;

        /**
         * @type {string}
         */
        this.css = params.css;

        /**
         * @type {string[]}
         */
        this.pts = params.pts || [];

        /**
         * @type {string[]}
         */
        this.pms = params.pms || [];

        /**
         * @type {string[]}
         */
        this.requireModules = params.requireModules || [];

        /**
         * @type {Object}
         */
        this.attrsTypes = params.attrsTypes || {};
    }
}

function putTag(tag) {
    var tagInfo = new TagInfo(tag);
    tagsCache[tag.name] = tagInfo;
    return tagInfo;
}

function loadTag(name) {
    if (tagsCache[name]) {
        return Promise.resolve(tagsCache[name]);
    }

    return Webapi.invoke('react/tag', { name }).then(function (tag) {
        return putTag(tag);
    })
}

function loadTags(names) {
    var res = [];
    var newNames = [];

    // Если по каким-то тегам инфа уже получена, то отдаем ее
    names.forEach(function (name) {
        if (tagsCache[name]) {
            res.push(tagsCache[name]);
        } else {
            newNames.push(name);
        }
    });

    if (!newNames.length) {
        return Promise.resolve(res);
    }

    return Webapi.invoke('react/tags', { names: newNames }).then(function (tags) {
        return res.concat(tags.map(function (tag) {
            return putTag(tag);
        }));
    })
}

function createElement(tagInfo, parts, container, attrs) {
    var node = document.createElement(tagInfo.name);

    node.setAttribute('data-react', tagInfo.js);

    if (tagInfo.css) {
        node.setAttribute('data-css', tagInfo.css);
    }

    if (attrs) {
        Object.keys(attrs).forEach(function (attrName) {
            node.setAttribute(attrName, JSON.stringify(attrs[attrName]));
        })

        node.setAttribute('data-props',JSON.stringify(attrs));
    }

    node.setAttribute('data-l10n', tagInfo.pts.join(','));
    node.setAttribute('data-cfg', tagInfo.pms.join(','));
    node.setAttribute('data-attrs-types', JSON.stringify(tagInfo.attrsTypes));
    node.setAttribute('data-module', 'react-loader');
    node.setAttribute('data-require-modules', tagInfo.requireModules.join(','));
    node.setAttribute('data-bundle-name', tagInfo.bundleName);
    node.classList.add('h-mod');

    // имя бандла в качестве класса
    node.classList.add(tagInfo.bundleName);

    var html = '';
    // Если есть парты, то их надо вставить в хтмл тега в <template>
    if (parts) {
        Object.keys(parts).forEach(function (name) {
            html += '<ui-part data-part-id="'+ name +'">'+ parts[name] +'</ui-part>';
        });
    }

    if (html) {
        html = '<template style="display: none">'+ html +'</template>';
        node.innerHTML = html;
    }


    return new Promise(function (resolve) {
        // Нужна обертка, потому, что активация работает для детей только
        var div = document.createElement('div');
        div.appendChild(node);

        import('OK/capture').then(m => m && m.default || m).then(function (capture) {
            if (container) {
                container.appendChild(div);
            }
            capture.activate(div);

            ReactInitializer.onAppReady(node).then(function () {
                if (container) {
                    container.appendChild(div.removeChild(node));
                    resolve(node);
                } else {
                    resolve(div.removeChild(node));
                }

                div.remove();
            });
        });
    });
}

function getTag(name, partCommands, container, attrs) {
    var requests = [
        loadTag(name)
    ];

    var partNames = [];

    if (partCommands) {
        partNames = Object.keys(partCommands);

        partNames.forEach(function (name) {
            var partCommand = partCommands[name];
            if (partCommand.commandName) {
                // объект из команды и параметров
                var commmandName = partCommand.commandName;
                var commandParams = partCommand.commandParams;
                requests.push(Webapi.invoke(commmandName, commandParams))
            } else {
                // просто команда
                requests.push(Webapi.invoke(partCommand))
            }

        });
    }

    return Promise.all(requests).then(function (results) {
        var partsCode = {};

        partNames.forEach(function (name, i) {
            partsCode[name] = results[i + 1];
        });

        return createElement(results[0], partsCode, container, attrs);
    });
}

function deactivate(node) {
    import('OK/capture').then(m => m && m.default || m).then(function (capture) {
        capture.deactivate(node);
    });
}

export default { putTag, loadTag, loadTags, createElement, getTag, deactivate };

export { putTag, loadTag, loadTags, createElement, getTag, deactivate };
